var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-loader"}},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("../../assets/logo-inverted.svg")}}),_vm._v(" "),_vm._t("default",function(){return [_vm._v("Loading your content...")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }